import React from "react";

import { Input } from "../../../../components/shared";
import { AppStrings } from "../../../../utils/constants/AppStrings";

import styles from "../stylesDynamicBonuses.module.css";

type ColorInputProps = {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  "data-testid"?: string;
};

const HEX6 = /^#[0-9A-Fa-f]{6}$/;
const HEX8 = /^#[0-9A-Fa-f]{8}$/;

/** Native `<input type="color">` only accepts #RRGGBB. */
function toPickerValue(hex: string | undefined): string {
  const trimmed = (hex ?? "").trim();
  if (HEX6.test(trimmed) || HEX8.test(trimmed)) {
    return trimmed.slice(0, 7).toLowerCase();
  }
  return "#000000";
}

/**
 * Single-color field: native color swatch on the left + hex text input for
 * paste/edit. Supports `#RRGGBB` and `#RRGGBBAA` in the text field; the picker
 * always writes `#RRGGBB`.
 */
const ColorInput: React.FC<ColorInputProps> = ({
  value,
  onChange,
  placeholder = "#FFFFFF",
  "data-testid": testId,
}) => {
  return (
    <div className={styles.colorInputRow}>
      <input
        type="color"
        className={styles.colorSwatch}
        aria-label={AppStrings.PAM_DYNAMIC_BONUS_BANNER_PICK_COLOR}
        value={toPickerValue(value)}
        onChange={(event) => onChange?.(event.target.value.toUpperCase())}
        data-testid={testId ? `${testId}-swatch` : undefined}
      />
      <Input
        value={value}
        onChange={(event) => onChange?.(event.target.value)}
        placeholder={placeholder}
        data-testid={testId}
      />
    </div>
  );
};

export default ColorInput;
